import React from 'react';
import { View, Text, Link } from '@react-pdf/renderer';
import { ATSResumeJson } from '@/types/resume';
import { styles } from '@/components/common/AtsResumePdfStyles';
import { parseRichText, getValidUrl } from './PdfUtils';

interface PdfHeaderProps {
  data: ATSResumeJson;
  showChanges: boolean;
}

export const PdfHeader = React.memo<PdfHeaderProps>(({ data, showChanges }) => {
  return (
    <View style={styles.header}>
      <Text style={styles.name}>{parseRichText(data.basics.name, showChanges)}</Text>
      {data.basics.title && (
        <Text style={styles.title}>{parseRichText(data.basics.title, showChanges)}</Text>
      )}
      
      <View style={styles.contactRow}>
        {[
          (data.basics.location && data.basics.location !== 'ACTION_REQUIRED_LOCATION') ? parseRichText(data.basics.location, showChanges) : null,
          data.basics.email ? parseRichText(data.basics.email, showChanges) : null,
          data.basics.phone ? parseRichText(data.basics.phone, showChanges) : null
        ].filter(Boolean).map((item, idx, arr) => (
          <React.Fragment key={idx}>
            <Text style={styles.contactItem}>{item}</Text>
            {idx < arr.length - 1 && <Text style={styles.contactItem}> | </Text>}
          </React.Fragment>
        ))}
      </View>
      
      {data.basics.urls && data.basics.urls.length > 0 && (
        <View style={[styles.contactRow, { marginTop: 4 }]}>
          {data.basics.urls.map((urlObj, idx) => {
            const validUrl = getValidUrl(urlObj.url);
            return (
              <React.Fragment key={idx}>
                {validUrl ? (
                  <Link src={validUrl} style={[styles.contactItem, styles.link]}>
                    {urlObj.label || urlObj.url.replace(/^https?:\/\/(www\.)?/, '')}
                  </Link>
                ) : (
                  <Text style={[styles.contactItem, urlObj.url === 'ACTION_REQUIRED_URL' || !urlObj.url ? { color: '#dc2626' } : {}]}>
                    {urlObj.label || urlObj.url || 'Action Required'}
                  </Text>
                )}
                {idx < data.basics.urls.length - 1 && <Text style={styles.contactItem}>|</Text>}
              </React.Fragment>
            );
          })}
        </View>
      )}
    </View>
  );
});
